export enum GroupsManagementTabs {
  DETAILS = 'Details',
  PERMISSIONS = 'Permissions',
  MEMBERS = 'Members',
}

export enum GroupsFilterType {
  ALL = 'All Groups',
  WORKROOMS_ONLY = 'Workrooms Only',
  COMMUNITIES_ONLY = 'Communities Only',
}

export const DEBOUNCE_TIME = 500;
export const MAX_GROUP_TITLE_CHARS = 100;
export const PAGE_SIZE = 20;
